import React, { useEffect, useState } from 'react'
import TroniaChat from './TroniaChat'
import { useTroniaVisible } from '../utils/troniaAcceso'

// [RGM] Widget flotante TronIA (diseño nuevo aprobado por Rafael).
// Réplica visual del FAB del repo de diseño (wwpdisenoia → inventario
// TroniaV2 docs/tronia-v1-widget-inventory.md); NO es réplica de lógica GX.
// El chat funcional vive en TroniaChat (componente compartido con el panel
// de Mi Cuenta) y consume los endpoints /api/tronia/* (TroniaController).
// - FAB con el CUBO de Cybertronica (asset cubo-icon.png, el icono
//   entregado para el FAB), fondo del tema (blanco light / oscuro dark),
//   borde --cui-primary, 48×48, radius 24px, icono CENTRADO en colapsado.
// - Efecto EXPANSIVO al hover: se estira a 140px y muestra el label
//   "TRONIA" a la izquierda del ícono (transición width 0.3s).
// - Panel de chat COMPACTO al abrir sin conversación y que CRECE con los
//   mensajes hasta su altura máxima; header con --cui-primary y subtítulo
//   "Asistente inteligente de Cybertronica"; todo el panel usa variables
//   CoreUI (--cui-card-bg, --cui-tertiary-bg, --cui-border-color) para
//   integrarse al tema light/dark activo.
// - Pulse en primera visita: flag tronia_first_visit en localStorage —
//   solo preferencia de UI de sesión (igual que el pulse aprobado de la
//   Fase 5), no es caché de datos de negocio (la app es ONLINE pura).
// - prop mode: 'public' → Tronia del Login (chat sin sesión); default 'chat'.

const TroniaFab: React.FC<{ mode?: 'chat' | 'public' }> = ({ mode = 'chat' }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [pulse, setPulse] = useState(false)
  // [RGM] 2026-09-17 (regla Rafael): el FAB es un enlace a TronIA → se oculta
  // si la empresa no tiene TronIA (PRUEBA/ACTIVO) o está en mora. En el Login
  // (mode="public") se mantiene siempre: es la demo pública, sin empresa.
  const troniaOk = useTroniaVisible()

  useEffect(() => {
    if (!localStorage.getItem('tronia_first_visit')) {
      setPulse(true)
      localStorage.setItem('tronia_first_visit', '1')
      const t = setTimeout(() => setPulse(false), 2000)
      return () => clearTimeout(t)
    }
  }, [])

  if (mode !== 'public' && !troniaOk) return null

  return (
    <div className={`tr-chat-wrapper${isOpen ? ' open' : ' closed'}`}>
      {/* Panel de chat: compacto sin conversación, crece con los mensajes */}
      <div className="tr-chat-panel" role="dialog" aria-label="TronIA">
        <div className="tr-chat-panel-header">
          <span className="tr-chat-panel-icon"><i className="fas fa-robot" /></span>
          <div>
            <div className="tr-chat-panel-title">TRONIA</div>
            <div className="tr-chat-panel-subtitle">Asistente inteligente de Cybertronica</div>
          </div>
          <button type="button" className="tr-chat-panel-close" onClick={() => setIsOpen(false)} aria-label="Cerrar">
            ✕
          </button>
        </div>
        <TroniaChat enabled compact mode={mode} />
      </div>

      {/* FAB con el cubo de Cybertronica (asset entregado) y expansión al hover */}
      <button
        type="button"
        className={`tr-fab-chat${pulse ? ' tr-fab-pulse' : ''}`}
        aria-label="Abrir TronIA"
        title="TronIA - Asistente Inteligente"
        onClick={() => setIsOpen((v) => !v)}
      >
        <span className="tr-fab-label">TRONIA</span>
        <span className="tr-fab-icon">
          <img src="/branding/cubo-icon.png" alt="TronIA" />
        </span>
      </button>
    </div>
  )
}

export default TroniaFab
